import { useState, useEffect, Suspense, useContext } from 'react';
import { useParams } from 'react-router-dom'
import { lazyImport } from '@/utils/lazyImport';
import { StoreContext } from '@/lib/store'
import { LoadingOverlay } from '@/components/Element/Loading';
const { NotFound } = lazyImport(() => import('../components/NotFound'), 'NotFound');
const { KeyForm } = lazyImport(() => import('../components/KeyForm'), 'KeyForm');
const { UploadForm } = lazyImport(() => import('../components/UploadForm'), 'UploadForm');
const { ShowDocument } = lazyImport(() => import('../components/ShowDocument'), 'ShowDocument');


export const Scan = () => {
    const params: any = useParams()
    const store = useContext(StoreContext);
    const { checkDivaId, checkDivaKey, logUser } = store.uploadStore

    const [keyVal, setKeyVal] = useState<String>("")
    const [divaId] = useState<String>(params.id)

    const [isSubmitted, setIsSubmitted] = useState<boolean>(null)
    const [isIdValid, setIsIdValid] = useState<boolean>(null)
    const [isKeyValid, setIsKeyValid] = useState<boolean>(null)
    const [isKeyFormLoading, setIsKeyFormLoading] = useState<boolean>(null)
    const [showSecurityForm, setShowSecurityForm] = useState<boolean>(null)
    const [showDocument, setShowDocument] = useState<boolean>(null)


    const handleInputKey = (event: any) => {
        setKeyVal(event.target.value.toUpperCase())
        setIsSubmitted(false)
    }

    const handleLogUser = (action:String,input:String) => {
        let param = {
            DIVA_ID: divaId,
            ACTION: action,
            INPUT: input
        }

        logUser(param).then(function (response) {
            //do nothing
            // console.log(response)
            
        })
            .catch((e) => {
                console.log(e)
            });
    }

    const handleSubmit = () => {

        setIsSubmitted(true)
        setIsKeyValid(null)
        setIsKeyFormLoading(true)

        if (keyVal == '') {
            setIsKeyValid(false)
        }
        else {

            ///check if key valid
            let validateParam = {
                VALIDATE: keyVal,
                DIVA_ID: divaId
            }
            checkDivaKey(validateParam).then(function (response) {
                setIsKeyValid(response.keyValid)
                setShowSecurityForm(response.security)
                setIsKeyFormLoading(false)

                if (response.keyValid) {
                    //log user to database
                    handleLogUser("KEY_SUBMIT","SUCCESS")
                }

                if (response.security) {
                    setShowDocument(false)
                }
                else {
                    setShowDocument(true)
                }
            })
                .catch((e) => {
                    console.log(e)
                });
        }
    }

    useEffect(() => {
        let validateParam = {
            VALIDATE: divaId,
            DIVA_ID: ""
        }
        checkDivaId(validateParam).then(function (response) {
            if (response) setIsIdValid(true)
            else setIsIdValid(false)
        })
            .catch((e) => {
                console.log(e)
            });

    }, [])

    return (
        <div className="container small" style={{ paddingTop: "15%" }}>
            <Suspense fallback={<LoadingOverlay loading={true} />}>
                {
                    (() => {
                        if (isIdValid) {
                            if (isSubmitted && isKeyValid) {
                                if (showSecurityForm && !showDocument) {
                                    return (
                                        ///render upload form
                                        <UploadForm
                                            setShowDocument={setShowDocument}
                                            handleLogUser={handleLogUser}
                                            divaId={divaId}
                                        />
                                    )
                                }
                                else if (showDocument) {
                                    return (
                                        //render document
                                        <ShowDocument divaId={divaId} x />
                                    )
                                }
                            }

                            return (
                                //render key form
                                <KeyForm
                                    isSubmitted={isSubmitted}
                                    keyVal={keyVal}
                                    isKeyValid={isKeyValid}
                                    isKeyFormLoading={isKeyFormLoading}
                                    handleInputKey={handleInputKey}
                                    handleSubmit={handleSubmit}
                                />
                            )
                        }
                        else if (isIdValid === false) {
                            //render document not found
                            return (
                                <NotFound />
                            )
                        }
                        else {
                            return (
                                <LoadingOverlay />
                            )
                        }


                    })()
                }
            </Suspense>




        </div>
    )
}